var render, staticRenderFns
import script from "./CourseV1.vue?vue&type=script&lang=js&"
export * from "./CourseV1.vue?vue&type=script&lang=js&"
import style0 from "./CourseV1.vue?vue&type=style&index=0&id=2a1588ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1588ba",
  null
  
)

export default component.exports